export default __webpack_public_path__ + "a3e06cca187cc659e87c841971076c0a.png";